import AppVersionDistributionCard from "@/v2-backoffice-client/appVersion/distribution/AppVersionDistributionCard"
import { useTableSortUrl } from "@/v2-backoffice-client/components/table"
import UserLoginPanel, {
  USER_LOGIN_TABLE_ID,
} from "@/v2-backoffice-client/userLogin/list/UserLoginPanel"

// The /activity "Sessions" tab: the fleet-wide acc.UserLogins list, topped by
// the fleet-wide cohort overview (how many users' latest login runs each app
// version — renders nothing until versioned logins exist).
function SignInSessionsTab() {
  // Bookmarkable sort for the fleet-wide instance only — the scoped sheet
  // instances of UserLoginPanel stay URL-free.
  const sortUrl = useTableSortUrl({ tableId: USER_LOGIN_TABLE_ID })

  return (
    <>
      <AppVersionDistributionCard className="mb-2" />
      <UserLoginPanel sortProps={sortUrl} />
    </>
  )
}

export default SignInSessionsTab
